import { format } from 'date-fns'
import { observer } from 'mobx-react'
import { useEffect } from 'react'
import { useParams } from 'react-router'

import type { ParentNoticeRes } from '~/@common/api/parentApi'
import { useRepository } from '~/@common/hooks/useRepository'
import { PortalRootLayoutHeader } from '~/@common/ui/PortalRootLayoutHeader'
import GlobalHeader from '~/@pages/@widgets/(Navigation)/GlobalHeader/GlobalHeader'

import { ParentNoticeService } from './ParentNotice.service'
import { S } from './ParentNoticeDetail.style'

const NOTICE_TYPE_PREFIX: Record<ParentNoticeRes['type'], string> = {
  NOTICE: '[공지]',
  PLAN: '[일정]',
  NEWS: '[소식]',
} as const

const ParentNoticeDetailPage = observer(() => {
  const { noticeId } = useParams<{ noticeId: string }>()
  const service = useRepository(ParentNoticeService)

  // 목록 페이지에서 이미 로드했으면 캐시 사용, 직접 진입 시 페치
  useEffect(() => {
    if (service.notices.length === 0 && !service.isLoading) {
      service.fetchNotices()
    }
  }, [service])

  const notice = service.findById(Number(noticeId))

  if (service.isLoading) {
    return null
  }

  if (!notice) {
    return <S.Empty>등록된 공지가 없습니다.</S.Empty>
  }

  return (
    <>
      <PortalRootLayoutHeader>
        <GlobalHeader
          SlotCenter={<span>공지</span>}
          style={{ borderBottom: '1px solid var(--Colors-Gray-300)' }}
        />
      </PortalRootLayoutHeader>

      <S.Content>
        <S.Date>{format(new Date(notice.createDatetime), 'yyyy.MM.dd')}</S.Date>
        <S.Title>
          {NOTICE_TYPE_PREFIX[notice.type]} {notice.title}
        </S.Title>
        <S.Body>{notice.content}</S.Body>
      </S.Content>
    </>
  )
})

export default ParentNoticeDetailPage
